"use client";
import { Stack, Typography, Box } from "@mui/material";
import Image from "next/image";
import { ShoppingPlatformItem } from "@/types/schema";
import ArrowRightTopIcon from "../icons/arrow_right_top_icon";

interface ShoppingPlatformCardProps {
  platform: ShoppingPlatformItem;
}

export function ShoppingPlatformCard({ platform }: ShoppingPlatformCardProps) {
  return (
    <Stack
      gap={{
        xs: 3,
        md: 6,
      }}
      alignItems="center"
      sx={{
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-4px)",
          transition: "transform 0.2s ease-in-out",
        },
      }}
      onClick={() => window.open(platform.url, "_blank")}
      p={{
        xs: 0,
        md: 6,
      }}
    >
      <Box
        sx={{
          borderRadius: "20px",
          overflow: "hidden",
          width: 88,
          height: 88,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          src={platform.logo}
          alt={platform.name}
          width={88}
          height={88}
          style={{
            width: "88px",
            height: "88px",
            objectFit: "cover",
            borderRadius: "20px",
          }}
        />
      </Box>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              md: "18px",
            },
            fontWeight: 400,
            lineHeight: {
              xs: "22px",
              md: "26px",
            },
            color: "#ffffff",
            fontFamily: "'Noto Sans Thai', sans-serif",
          }}
        >
          {platform.name}
        </Typography>
        <ArrowRightTopIcon width={11} height={11} color="#ffffff" />
      </Stack>
    </Stack>
  );
}
